<template>
  <basic-card class="global-basic-card" padding hideHeader :hasMore="showMore">
    <avue-crud
      class="global-table"
      :key="tableKey"
      :option="option"
      :data="data"
      v-model:page="page"
      v-model="form"
      v-model:search="search"
      :table-loading="scopeLoading"
      ref="crud"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ CURRENT_LANGUAGE.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ CURRENT_LANGUAGE.btn.empty }}
            </comp-button>
          </div>
          <div>
          </div>
        </div>
      </template>
      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <comp-button
            type="primary"
            icon="icon-add"
            v-if="permissionObj.add" 
            @click.stop="handleAdd()"
            >{{ CURRENT_LANGUAGE.btn.addNew }}
          </comp-button>
        </div>
      </template>
      <template #menu="{row}">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" :text="CURRENT_LANGUAGE.btn.view" type="view" @click="handleView(row)" :divider="row.createTenant == userInfo.tenant_id" > </CompIconButton>
          <CompIconButton :auth="permissionObj" :text="CURRENT_LANGUAGE.btn.edit" v-if="row.createTenant == userInfo.tenant_id" type="edit" @click="handleEdit(row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" :text="CURRENT_LANGUAGE.btn.delete" v-if="row.createTenant == userInfo.tenant_id" type="delete" :divider="false" @click="handleDel(row)" > </CompIconButton>
        </div>
      </template>
      <template #scopeType="{ row }">
        <el-tag>{{ row.scopeTypeName }}</el-tag>
      </template>
      <template #page>
        <CompPagination
          v-model:current-page="page.currentPage"
          :page-size="page.pageSize"
          :total-text="CURRENT_LANGUAGE.Text.basicTxTotal"
          :item-text="CURRENT_LANGUAGE.Text.itemText"
          :per-page-text="CURRENT_LANGUAGE.Text.basicItemText+'/'+CURRENT_LANGUAGE.Text.basicTxPage"
          :goto-text="CURRENT_LANGUAGE.Text.basicTxGoTo"
          :page-text="CURRENT_LANGUAGE.Text.basicTxPage"
          background
          layout="total, sizes, ->, prev, pager, next, jumper"
          :total="page.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </template>
    </avue-crud>
  </basic-card>
  <el-dialog
      direction="rtl"
      width="952px"
      :close-on-click-modal="false"
      class="global-dialog"
      :title="operation=='add' ? Lang.Button.standardPointAddPoint : operation=='view' ? Lang.Title.standardPointPoint :  Lang.Title.standardPointEditPoint"
      v-model="showAddMeasurementPoint"
    >
    <addStandarMeasurementPoint 
      v-if="showAddMeasurementPoint"
      :itemId="itemId"
      :operation="operation"
      @submit="onSubmit"
      @cancel="onCancel"
    ></addStandarMeasurementPoint>
  </el-dialog>
</template>

<script>
import {
  getPage,
  getDetail,
  submit,
  remove,
} from '@/api/gateway/measurementPoint';
import { mapGetters } from 'vuex';
import { filterDollarKeys } from '@/utils/util';
import addStandarMeasurementPoint from './comps/addStandarMeasurementPoint.vue';
import { LANGUAGE_OPTIONS, getCountryLangOptions } from '@/lang/language';
import { getLanguage, Lang } from '@/lang/lang';
import CompPagination from '@/components/comp-pagination/index.vue';

export default {
  components: {
    addStandarMeasurementPoint,
    CompPagination,
  },
  data() {
    return {
      CURRENT_LANGUAGE: {},
      currentLangKey: 'en-US',
      tableKey: 0,
      form: {},
      itemId: '',
      operation: 'add',
      selectionList: [],
      query: {},
      search: {
        language: 'en-US', // 设置初始值为 'en-US'
      },
      showAddMeasurementPoint: false,
      loading: true,
      showMore: true,
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      drawerVisible: false,
      direction: 'rtl',
      scopeLoading: false,
      scopeMenuId: 0,
      scopeMenuName: this.Lang.label.menu,
      menu: true,
      data: [],
      selectionList: [],
      option: {
        pagination: {
          layout: 'total, sizes, prev, pager, next, jumper', // 分页布局
          locale: 'en-US', // 设置分页语言为英文
        },
        tip: false,
        searchShow: true,
        searchSpan: 4,
        searchMenuSpan: 8,
        searchLabelWidth: 'auto',
        searchLabelSuffix: ' ',
        gutter: 20,
        border: true,
        index: true,
        emptyBtn: false,
        searchBtn: false,
        border: false, // 关键
        menuWidth: 146, // 操作列宽
        addBtn: true, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        selection: true,
        menuWidth: 116,
        dialogWidth: 900,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        dialogClickModal: false,
        showOverflowTooltip: true,
        labelPosition: 'top',
        column: [
          {
            label: this.Lang.Title.standardPointLangVer,
            prop: 'language',
            type: 'select',
            search: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
            hide: true,
            valueDefault: 'en-US',
            dicData: LANGUAGE_OPTIONS,
            props: {
              value: 'key',
              label: 'i18nValue',
            },
            onChange: (row) => {
              this.updateLanguage(row.value); // 调用更新语言的方法
            },
          },
          {
            label: 'ID',
            prop: 'id',
            search: true,
            editDisplay: false,
            viewDisplay: false,
            addDisplay: false,
          },
          {
            label: this.Lang.label.measurePoint,
            prop: 'name',
            slot: true,
            search: true,
          },
          {
            label: this.Lang.Title.standardPointType,
            prop: 'stype',
            search: true,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=typesOfTelemetering',
            dataType: 'string',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
          },
          {
            label: this.Lang.Title.standardPointFormat,
            prop: 'datatypeName',
            search: false,
          },
          {
            label: this.Lang.Title.standardPointUnit,
            prop: 'unit',
            slot: true,
            search: false,
          },
          {
            label: this.Lang.Title.standardPointEnumDef,
            prop: 'itemEnum',
            search: false,
          },
          {
            label: this.Lang.Title.standardPointNote,
            prop: 'desc',
            slot: true,
            search: false,
          },
          {
            label: this.Lang.label.pvsttdbUpdated,
            prop: 'updateTime',
            search: false,
          },
        ],
      },
    };
  },

  computed: {
    ...mapGetters(['menuItem', 'permission', 'language', 'userInfo']),
    // CURRENT_LANGUAGE() {
    //   return getLanguage(this.language);
    // },
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    scopeIds() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.search.language = 'en-US'; // 默认当前语言为 'en-US'
  },
  methods: {
      updateLanguage(newLang) {
        this.CURRENT_LANGUAGE = getLanguage(newLang); // 更新当前语言
        this.currentLangKey = newLang; // 更新语言键
        this.search.language = newLang; // 更新搜索条件中的语言

        this.updatePageLabels(newLang); // 更新页面中的所有标签
        this.handleSearch(); // 重新触发搜索
    },

    updatePageLabels(newLang) {
      // 更新表头和其他页面内容
      this.option.indexLabel = this.CURRENT_LANGUAGE.table.serialNumber;
      this.option.menuTitle = this.CURRENT_LANGUAGE.label.operation;

      this.option.column.forEach((item) => {
        if (item.prop === 'id') {
          item.label = this.CURRENT_LANGUAGE.Title.standardPointPointId;
        } else if (item.prop === 'unit') {
          item.label = this.CURRENT_LANGUAGE.label.unit;
        } else if (item.prop === 'des') {
          item.label = this.CURRENT_LANGUAGE.Title.standardPointNote;
        } else if (item.prop === 'updateTime') {
          item.label = this.CURRENT_LANGUAGE.label.updateTime;
        } else if (item.prop === 'name') {
          item.label = this.CURRENT_LANGUAGE.label.measurePoint;
        } else if (item.prop === 'stype') {
          item.label = this.CURRENT_LANGUAGE.Title.modelType;
        } else if (item.prop === 'datatypeName') {
          item.label = this.CURRENT_LANGUAGE.Title.modelFormat;
        } else if (item.prop === 'itemEnum') {
          item.label = this.CURRENT_LANGUAGE.Title.standardPointEnumDef;
        } else if (item.prop === 'language') {
          item.label = this.CURRENT_LANGUAGE.label.language;
          const opts = getCountryLangOptions(true, newLang);
          opts.forEach((item) => {
            item.i18nValue = this.CURRENT_LANGUAGE.label[item.labelKey];
          });
          item.dicData = opts;
        } else if (item.prop === 'desc') {
          console.log(this.CURRENT_LANGUAGE.Title.standardPointNote)
          item.label = this.CURRENT_LANGUAGE.Title.standardPointNote;
        }
        item.searchPlaceholder = this.CURRENT_LANGUAGE.tips.plzInput + ' ' + item.label;

      });
    },
    // 自定义查看
    handleView(row) {
      this.operation = 'view';
      this.itemId = row.id;
      this.showAddMeasurementPoint = true;
    },
    // 自定义编辑
    handleEdit(row) {
      this.operation = 'edit';
      this.itemId = row.id;
      this.showAddMeasurementPoint = true;
    },
    // 自定义删除
    handleDel(row) {
      // 删除组织红色弹框
      this.$dialog({
        title: this.Lang.Title.standardPointDelPoint,
        titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
        icon: 'danger',
        iconSize: '50px',
        iconColor: '#FEF3F2',
        measurePointTitle: this.Lang.Title.standardPointPoint,
        measurePoint: row.name,
        content: `<div style="color:red;margin:8px 0;">${this.Lang.Text.standardPointDelPointCon}</div>`,
        confirmButtonText: this.Lang.btn.delete,
        cancelButtonText: this.Lang.btn.cancel,
        cancelButtonType: 'delete',
        confirmButtonType: 'danger',
        showClose: false,
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
      // this.$refs.crud.rowDel(row);
    },
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.option.selection = this.showMore;
      this.tableKey += 1;
    },
    // 自定义搜索
    handleSearch() {
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义添加
    handleAdd() {
      this.operation = 'add';
      this.showAddMeasurementPoint = true;
    },
    filterChange(filter) {
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    treeLoad(tree, treeNode, resolve) {
      const parentId = tree.id;
      getLazyMenuList(parentId).then(res => {
        resolve(res.data.data);
      });
    },
    onCancel() {
      this.showAddMeasurementPoint = false;
    },
    onSubmit(params) {
      submit(params).then(res => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.onLoad(this.page, this.query);
          this.showAddMeasurementPoint = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 无用的函数，保留
    rowSave(row, done, loading) {
      row = {
        ...row,
        menuId: this.scopeMenuId,
      };
      submit(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 无用的函数，保留
    rowUpdate(row, index, done, loading) {
      row = {
        ...row,
        menuId: this.scopeMenuId,
      };
      submit(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 无用的函数，保留
    rowDel(row) {
      this.$confirm( this.Lang.tips.ifConfirmDelete, this.Lang.Title.standardPointDelPoint, {
        content: this.Lang.tips.ifConfirmDelete,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    // 无用的函数，保留
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.scopeIds);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess, 
          });
          this.$refs.crud.toggleSelection();
        });
    },
    // 无用的函数，保留
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({id: this.form.id}).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad(this.page, this.query);
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.scopeLoading = true;
      const values = {
        ...params,
      };
      this.query.language = this.currentLangKey;
      const mergeParam = Object.assign(this.query, values);
      this.query = mergeParam;
      getPage(page.currentPage, page.pageSize, mergeParam, this.currentLangKey).then(
        res => {
          const data = res.data.data;
          this.page.total = data.total;
          data.records.forEach(item => {
            item.desc = item.des;
          })
          this.data = data.records;
          this.selectionList = [];
          this.scopeLoading = false;
        }
      );
    },
  },
};
</script>
<style scoped>
/* 隐藏默认分页器 */
.custom-pagination ~ * {
  display: none;
}

</style>